const messages = {
  title: "Campagne di vendita",
  desc: "Utilizza attivamente le nostre campagne di vendita con i tuoi clienti. Puoi naturalmente offrire entrambe le iniziative. Scopri di più sulla Garanzia Pneumatici e sulla campagna Drive Our Best qui sotto.",
  participation: {
    title: "Richiedi la partecipazione ora",
    desc: "Vuoi attivare una o più campagne nel tuo punto vendita? Puoi richiederlo da qui. La tua azienda verrà attivata per la/e campagna/e e riceverai entro 4 settimane i materiali pubblicitari per supportare le vendite.<br/><br/>Fai la tua scelta:",
    request: "RICHIEDI PARTECIPAZIONE",
    success: "Grazie, la tua richiesta è stata inviata",
  },
};
export default {
  messages,
};
